import { render, staticRenderFns } from "./BuyOrSell.vue?vue&type=template&id=337ade5b"
import script from "./BuyOrSell.vue?vue&type=script&lang=js"
export * from "./BuyOrSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports